import {messages} from '@smartmixin/i18n';
import React from 'react';
import {useIntl} from 'react-intl';
import {useDispatch, useSelector} from 'react-redux';
import {useUserLoggedIn} from './userContext';
import {WeatherService} from '../api';
import {WeatherStationFromList} from '../api/types';
import {
  addFavoriteStation,
  removeFavoriteStation,
  selectFavoriteStationIds,
  setAlert,
} from '../store';
import useApiClient from './useApiClient';

const useFavoriteStation = () => {
  const {fetch} = useApiClient();
  const {formatMessage} = useIntl();
  const dispatch = useDispatch();

  const isLoggedIn = useUserLoggedIn();
  const favoriteIds = useSelector(selectFavoriteStationIds);

  const addFavorite = React.useCallback(
    (stationId: number) => {
      if (isLoggedIn) {
        fetch(WeatherService.addFavoriteStation(stationId))
          .then((station: WeatherStationFromList) => {
            dispatch(addFavoriteStation(station.id));
            dispatch(
              setAlert({
                type: 'INFO',
                message: formatMessage(messages.common.stationAddedToFavorites),
              }),
            );
          })
          .catch(() => {});
      } else {
        dispatch(addFavoriteStation(stationId));
        dispatch(
          setAlert({
            type: 'INFO',
            message: formatMessage(messages.common.stationAddedToFavorites),
          }),
        );
      }
    },
    [dispatch, fetch, formatMessage, isLoggedIn],
  );

  const removeFavorite = React.useCallback(
    (stationId: number) => {
      if (isLoggedIn) {
        fetch(WeatherService.removeFavoriteStation(stationId))
          .then(() => {
            dispatch(removeFavoriteStation(stationId));
            dispatch(
              setAlert({
                type: 'INFO',
                message: formatMessage(
                  messages.common.stationRemovedFromFavorites,
                ),
              }),
            );
          })
          .catch(() => {});
      } else {
        dispatch(removeFavoriteStation(stationId));
        dispatch(
          setAlert({
            type: 'INFO',
            message: formatMessage(messages.common.stationRemovedFromFavorites),
          }),
        );
      }
    },
    [dispatch, fetch, formatMessage, isLoggedIn],
  );

  return {addFavorite, removeFavorite, favoriteIds};
};

export default useFavoriteStation;
